import { Box, Divider, IconButton, ListItem, ListItemText, Typography } from '@mui/material';
import Grid from '@mui/material/Grid2';
import List from '@mui/material/List';
import React from 'react';

interface NavItem {
  label: string;
  path: string;
}

interface HelpItem {
  label: string;
  path: string;
}

const navItems: NavItem[] = [
  { label: 'Our Products', path: '/' },
  { label: 'About Us', path: '/products' },
  { label: 'For Vendors', path: '/contact' },
  { label: 'Design With AI', path: '/contact' },
];

const helpItems: HelpItem[] = [
  { label: 'Contact Us', path: '/' },
  { label: 'FAQs', path: '/products' },
  { label: 'Privacy Policy', path: '/contact' },
  { label: 'Terms & Conditions', path: '/contact' },
];

const Footer: React.FC = () => {
  return (
    <>
      <Box sx={{ margin:'auto', backgroundColor: '#957db9', minHeight: '20vh', width:'100%' }}>
        <Box width={'80%'} sx={{ flexGrow: 1, margin: 'auto' }}>
          <Grid container columnSpacing={2}>
            <Grid size={2} style={{ height: '100%', margin: 'auto', textAlign: 'center' }}>
              <Box sx={{ fontSize: '30px', fontWeight: 'Bold', margin: 'auto' }}>
                <IconButton edge="start" color="inherit" aria-label="logo">
                  <img src={'/MZLogo.png'} alt="Logo" style={{ height: 100 }} />
                </IconButton>
                <Typography sx={{  mt: 0, mb: 0  }} variant="h4" component="div" style={{ color:'white', fontWeight: 'bold' }}>
                  MerchZ
                </Typography>
              </Box>
            </Grid> 
            <Grid size="grow" style={{ height: '100%', margin: 'auto', textAlign: 'center' }}>
            </Grid>
            <Grid size={2} style={{ height: '100%', margin: 'auto', textAlign: 'left' }}>
              <Box sx={{ fontSize: '30px', fontWeight: 'Bold', margin: 'auto', color:'white' }}>
                <Typography sx={{  mt: 4, mb: 0  }} variant="h6" component="div" style={{ color:'inherit', fontWeight: 'bold' }}>
                    Quick Links
                </Typography>
                <List>
                  {navItems.map((item, index) => (
                    <ListItem style={{ paddingLeft: '0' }} key={index}>
                      <ListItemText primary={item.label} />
                    </ListItem>
                  ))}
                </List>
              </Box>
            </Grid>
            <Grid size={2} style={{ height: '100%', margin: 'auto', textAlign: 'left' }}>
              <Box sx={{ fontSize: '30px', fontWeight: 'Bold', margin: 'auto', color:'white' }}>
                <Typography sx={{ mt: 4 }} variant="h6" component="div" style={{ color:'inherit', fontWeight: 'bold' }}>
                  Help
                </Typography>
                <List>
                  {helpItems.map((item, index) => (
                    <ListItem style={{ paddingLeft: '0' }} key={index}>
                      <ListItemText primary={item.label} />
                    </ListItem>
                  ))}
                </List>
              </Box>
            </Grid>
          </Grid>
          <Divider style={{ marginBottom:'2vh', color:'white', backgroundColor:'white' }}></Divider>
          <Grid container columnSpacing={2}>
            <Grid size={12} style={{ height: '100%', margin: 'auto', textAlign: 'left' }}>
              <Box sx={{ fontSize: '30px', fontWeight: 'Bold', margin: 'auto', color:'white' }}>
                <Typography sx={{  mt: 0, mb: 0  }} variant="h6" component="div" style={{ color:'inherit' }}>
                  © 2024. MerchZ AI Technologies Pvt Limited. All Rights Reserved
                </Typography>
              </Box>
            </Grid>
          </Grid>
        </Box>
      </Box>
    </>
  );
};

export default Footer;